import { setRoleDetailsData, resetRoleDetailsData } from '../../../redux/roleDetailsDataSlice';
import { SuccessfullModifyDialog } from '../../SuccessfullModifyDialog';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useCallback, useEffect, useState } from 'react';
import ReadRoleCredentials from './readRoleCredentials';
import { Box, CircularProgress } from '@mui/material';
import RoleDetailsHeader from './roleDetailsHeader';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';

const RoleDetails = () => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    const fetchRoleDetails = useCallback(async () => {
        try {
            const response = await axios.get(`role/${id}`);
            if (response.status === 200 || response.status === 201) {
                dispatch(setRoleDetailsData(response.data));
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error Fetching role:', error);
            CustomErrorLogger(error, "Fetch Role Details Error in RoleDetails");
        }
    }, [id, dispatch]);

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchRoleDetails()
        return () => {
            dispatch(resetRoleDetailsData());
        };
    }, [fetchRoleDetails, id, dispatch]);

    return (
        <Box>
            {loading ?
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '80vh',
                    }}
                >
                    <CircularProgress
                        sx={{
                            '& .MuiCircularProgress-circle': { stroke: '#EA5E00' },
                        }}
                    />
                </Box>
                :
                <Box>
                    <RoleDetailsHeader />
                    <SuccessfullModifyDialog />
                    <ReadRoleCredentials />
                </Box>
            }
        </Box>
    );
}

export default RoleDetails;